import { MaterialResources } from "@/state/MaterialResources";
import React from "react";
import { Color } from "three";
import { FurnitureInstance, FurnitureWithModel } from "@/state/Furniture";
import { getSuitableMaterials } from "@/3d/material/getSuitableMaterial";
import { MaterialSlotView } from "./MaterialSlotView";

type MaterialSectionProps = {
    instance: FurnitureInstance;
    furniture: FurnitureWithModel;
    materials: Record<string, MaterialResources>;
    onMaterialNameChange: (slotId: string, materialName: string) => void;
    onMaterialColorChange: (slotId: string, color: Color) => void;
};

export const MaterialSection: React.FC<MaterialSectionProps> = ({
    instance,
    furniture,
    materials,
    onMaterialColorChange,
    onMaterialNameChange,
}) => {
    const selectableMaterialSlots = Object.values(furniture.model.config.materialSlots)
        .filter((slot) => slot.type === "selectable")
        .map((slot) => ({
            ...slot,
            materials: getSuitableMaterials(slot, materials),
        }));

    return (
        <>
            {selectableMaterialSlots.map((slot) => (
                <MaterialSlotView
                    key={slot.id}
                    slot={slot}
                    instance={instance}
                    furniture={furniture}
                    availableMaterials={slot.materials}
                    onMaterialNameChange={(materialName) =>
                        onMaterialNameChange(slot.id, materialName)
                    }
                    onMaterialColorChange={(color) => onMaterialColorChange(slot.id, color)}
                />
            ))}
        </>
    );
};
